import { createSelector } from "@reduxjs/toolkit";
import _ from "underscore";

import type { PlanLoaderState } from "Common/PlanLoader/Selectors";
import { getPlans, getSortConfig } from "Common/PlanLoader/Selectors";

export const getFavoritePlanIDs = (state: PlanLoaderState): Array<string> => state.favoritePlanIDs;

export const isPlanFavorited: (state: PlanLoaderState, planId: string) => boolean = createSelector(
  [getFavoritePlanIDs, (_state, planId) => planId],
  (favoritePlanIDs, planId) => favoritePlanIDs.includes(planId),
);

export const getFavoritePlans: (arg0: PlanLoaderState) => Array<MedicalPlanPrice> = createSelector(
  [getFavoritePlanIDs, getPlans],
  (favoritePlanIDs: Array<string>, plans: Array<MedicalPlanPrice>): Array<MedicalPlanPrice> =>
    favoritePlanIDs.map((id) => _.findWhere(plans, { id })).filter((p) => p),
);

export const getSortedFavoritePlans: (arg0: PlanLoaderState) => Array<MedicalPlanPrice> = createSelector(
  [getSortConfig, getFavoritePlans],
  (sortConfig: string, plans: Array<MedicalPlanPrice>): Array<MedicalPlanPrice> => {
    if (sortConfig === "score") {
      return plans.sort((plan1, plan2) => plan1.boosted_score - plan2.boosted_score);
    }
    if (sortConfig === "average_monthly_premium") {
      return plans.sort((plan1, plan2) => plan1.average_monthly_premium - plan2.average_monthly_premium);
    }
    return plans;
  },
);
